function isContactLensesOrderLineItem(orderLineItem) {
    return 'eyeSide' in orderLineItem;
}
function isNonPrescriptionBundleOrderLineItem(orderLineItem) {
    return 'configurationDetails' in orderLineItem && !('prescription' in orderLineItem);
}
function isGlassesBundleOrderLineItem(orderLineItem) {
    return 'configurationDetails' in orderLineItem && 'prescription' in orderLineItem;
}
function isSolutionOrderLineItem(orderLineItem) {
    return 'product' in orderLineItem && 'volume' in orderLineItem.product;
}

export { isContactLensesOrderLineItem, isGlassesBundleOrderLineItem, isNonPrescriptionBundleOrderLineItem, isSolutionOrderLineItem };
//# sourceMappingURL=order-line-item-product-type-guards.js.map
